import useSWR, { mutate } from 'swr';
import { useMemo } from 'react';

// project-import
const countries = [
  { code: 'US', label: 'United States Dollar', currency: 'Dollar', prefix: '$' },
  { code: 'GB', label: 'United Kingdom Pound', currency: 'Pound', prefix: '£' },
  { code: 'IN', label: 'India Rupee', currency: 'Rupee', prefix: '₹' },
  { code: 'JP', label: 'Japan Yun', currency: 'Yun', prefix: '¥' }
];

const initialState = {
  isOpen: false,
  isCustomerOpen: false,
  open: false,
  country: countries[0],
  countries: countries,
  alertPopup: false
};

const initialInvoiceState = { invoice: [] };

export const endpoints = {
  key: 'invoice',
  actions: ':actions',
  list: ':list',
  insert: ':insert',
  update: ':update',
  delete: ':delete'
};

export function useGetInvoice() {
  const { data, isLoading, error, isValidating } = useSWR(endpoints.key + endpoints.list, null, {
    fallbackData: initialInvoiceState,
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false
  });

  const memoizedValue = useMemo(
    () => ({
      invoice: data?.invoice,
      invoiceLoading: isLoading,
      invoiceError: error,
      invoiceValidating: isValidating,
      invoiceEmpty: !isLoading && !data?.invoice?.length
    }),
    [data, error, isLoading, isValidating]
  );

  return memoizedValue;
}

export function useGetInvoiceMaster() {
  const { data, isLoading } = useSWR(endpoints.key + endpoints.actions, () => initialState, {
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false
  });

  const memoizedValue = useMemo(
    () => ({
      invoiceMaster: data,
      invoiceMasterLoading: isLoading
    }),
    [data, isLoading]
  );

  return memoizedValue;
}

export function handlerCustomerTo(isCustomerOpen) {
  // to update local state based on key
  mutate(
    endpoints.key + endpoints.actions,
    (currentInvoicemaster) => {
      return { ...currentInvoicemaster, isCustomerOpen };
    },
    false
  );
}

export function handlerCustomerFrom(open) {
  // to update local state based on key
  mutate(
    endpoints.key + endpoints.actions,
    (currentInvoicemaster) => {
      return { ...currentInvoicemaster, open };
    },
    false
  );
}

export function selectCountry(country) {
  // to update local state based on key
  mutate(
    endpoints.key + endpoints.actions,
    (currentInvoicemaster) => {
      return { ...currentInvoicemaster, country };
    },
    false
  );
}

export function handlerPreview(isOpen) {
  // to update local state based on key
  mutate(
    endpoints.key + endpoints.actions,
    (currentInvoicemaster) => {
      return { ...currentInvoicemaster, isOpen };
    },
    false
  );
}

export function handlerDelete(alertPopup) {
  // to update local state based on key
  mutate(
    endpoints.key + endpoints.actions,
    (currentInvoicemaster) => {
      return { ...currentInvoicemaster, alertPopup };
    },
    false
  );
}